import { useContext } from "react";
import { TipContext } from "../../containers/TipContext";
import Tippy from "@tippyjs/react";
import styles from "./Rune.module.css";

const Rune = ({ rune, size = 30, flex = "", filter = false }) => {
  const tips = useContext(TipContext);
  const tip =
    tips.rune && tips.rune[rune + flex] ? tips.rune[rune + flex] : "Loading...";
  return (
    <>
      <Tippy
        content={
          <div
            className={
              tips.rune && tips.rune[rune + flex] ? "" : styles.loading
            }
            dangerouslySetInnerHTML={{ __html: tip }}
          />
        }
        onShow={() => {
          if (!tips.showRune) tips.setShowRune(true);
        }}
      >
        <div>
          {rune > 5013 && (
            <img
              width={size}
              height={size}
              className={`${filter ? styles.grey : ""}`}
              src={`https://cdn5.xdx.gg/rune${size}/${rune}.webp`}
              srcSet={`https://cdn5.xdx.gg/rune${size}/${rune}.webp ${size}w,
                   https://cdn5.xdx.gg/rune${size * 2}/${rune}.webp ${
                size * 2
              }w`}
              alt={rune}
            />
          )}
          {rune < 5014 && (
            <img
              width={size}
              height={size}
              className={`${filter ? styles.grey : ""}`}
              src={`https://cdn5.xdx.gg/statmod32/${rune}.webp`}
              alt={rune}
            />
          )}
        </div>
      </Tippy>
    </>
  );
};

export default Rune;
